import { createRoute, lazyRouteComponent } from "@tanstack/react-router";

import { rootRoute } from "../__root";

export const usersLoginRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/users/login",
  component: lazyRouteComponent(
    () =>
      import(
        /* webpackChunkName: "OnboardingSignInPage" */ "@circle-react/components/OnboardingPage/SignInPage"
      ),
    "SignInPage",
  ),
});
